const moment = require("moment/moment");
const {forEach} = require("underscore");

function hasAvailability(serviceId, privacyType) {
    const service = currentSubproducts.find(function (subproduct) {
        return String(subproduct.service_id) === String(serviceId);
    })

    const tourDate = $('#tour_date').val();

    if (window.subproductAvailableDates) {
        const dates = window.subproductAvailableDates[serviceId];
        return Boolean(service && dates && Array.isArray(dates[privacyType])
            && dates[privacyType].includes(tourDate));
    }

    const currentAvailabilitySlots = getSubproductAvailabilitySlots(tourDate, privacyType);
    if (!service || !checkSubproductAvailability(currentAvailabilitySlots, service)) {
        return false;
    }

    let availabilityCount = 0;
    forEach(currentAvailabilitySlots, function (slot) {
        if (!slotMatchesAvailabilityService(slot, service.availability_service_id)) {
            return;
        }
        let startDateTime = tourDate + ' ' + slot.hour;
        if (calculateCutOff(privacyType, service, startDateTime) === true) {
            availabilityCount++;
        }
    });

    return availabilityCount !== 0;
}

function getSubproductAvailabilitySlots(tourDate, privacyType) {
    const availability = window.availabilityRawData;
    const privacyAvailability = availability && availability[privacyType];
    const availabilityForDay = privacyAvailability
        ? privacyAvailability.find(day => day.date === tourDate)
        : undefined;

    if (!availabilityForDay) {
        return [];
    }

    return getAvailabilitySlots(availabilityForDay);
}

function checkSubproductAvailability(slots, service) {
    if (!Array.isArray(slots) || !service || service.availability_service_id == null) {
        return false;
    }

    return slots.some(slot => slotMatchesAvailabilityService(slot, service.availability_service_id));
}

function slotMatchesAvailabilityService(slot, serviceId) {
    return slot && Array.isArray(slot.availability_service_ids)
        && slot.availability_service_ids.some(id => id != null && String(id) === String(serviceId));
}

function getAvailabilitySlots(availabilityForDay) {
    if (!availabilityForDay || !Array.isArray(availabilityForDay.services)) {
        return [];
    }
    return availabilityForDay.services.reduce((slots, service) => (
        slots.concat(Array.isArray(service.slots) ? service.slots : [])
    ), []);
}

function calculateCutOff(privacyType, service, tourDate) {
    let cutOffTime;
    let reverseCutOffTime;
    if (privacyType === 'Private') {
        cutOffTime = service.cut_off_time_private;
        reverseCutOffTime = service.reverse_cut_off_time_private;

    } else {
        cutOffTime = service.cut_off_time_shared;
        reverseCutOffTime = service.reverse_cut_off_time_shared;
    }

    let cutOffTimeMoment = calculateCutOffTimeMoment(cutOffTime);
    let reverseCutOffTimeMoment = calculateCutOffTimeMoment(reverseCutOffTime);

    return calculateAvailabilities(tourDate, cutOffTimeMoment, reverseCutOffTimeMoment, true, privacyType);
}

function calculateCutOffTimeMoment(cutOffTime) {
    if (!cutOffTime || cutOffTime === '00:00:00') return null;

    let [hours, minutes, seconds] = cutOffTime.split(':').map(Number);
    let cutOffTimeInMilliseconds = hours * 3600000 + minutes * 60000 + seconds * 1000;

    return moment().add(cutOffTimeInMilliseconds, 'milliseconds');
}

function calculateAvailabilities(currentAvailability, cutOffTimeMoment, reverseCutOffTimeMoment, formatDates, privacyType) {
    let startDate = moment(currentAvailability, 'YYYY-MM-DD HH:mm:ss');
    let currentAvailabilityDay = startDate.format('YYYY-MM-DD');
    if (!window.availabilityDay || !Array.isArray(window.availabilityDay[privacyType])
        || !window.availabilityDay[privacyType].includes(currentAvailabilityDay)) {
        return false;
    }

    let isAfterCutOff = !cutOffTimeMoment || startDate.isAfter(cutOffTimeMoment);
    let isBeforeReverseCutOff = !reverseCutOffTimeMoment || startDate.isBefore(reverseCutOffTimeMoment);

    return isAfterCutOff && isBeforeReverseCutOff;
}

function generateServiceLangsOptions(selectElement, privacyType) {
    selectElement.empty();

    let langsArray = [];
    if (privacyType === 'Private') {
        langsArray = currentServiceLangs.private;
    } else {
        langsArray = currentServiceLangs.group;
    }

    langsArray.forEach(langData => {
        const langId = langData.id;
        const langLabel = langData.label;
        const option = document.createElement('option');

        option.value = langId;
        option.textContent = langLabel;
        selectElement.append(option);
    });


}

module.exports = {hasAvailability, checkSubproductAvailability, generateServiceLangsOptions};
